import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from './ManageToken';
import { Navbar, Sidebar } from '../app/common';

const PrivateRoute = ({children}) => {
  const token = getToken();
  const isMobile = window.innerWidth <= 768;

  if (!token) {
    return <Navigate to="/" replace />;
  }


  if (isMobile) {
    return (
      <div className="main-section position-relative">
      <div className="main-section-right">
        <div className="main-content-wrapper">
      <Navbar />

          {children}
        </div>
      </div>
    </div>
    );
  }


  return (
    <div className="main-section position-relative">
      <Sidebar />
      <div className="main-section-right">
        <div className="main-content-wrapper">
      <Navbar />

          {children}
        </div>
      </div>
    </div>
  );
};

export default PrivateRoute;
